// extracted by mini-css-extract-plugin
export default {"WhatsNewPage":"WhatsNewPage_WhatsNewPage__5G6V+","Panel":"WhatsNewPage_Panel__DLr+q"};